
import React from 'react';
import PageTitle from '../hooks/PageTitle';
import PageHeader from '../layouts/PageHeader';
import SectionComposition from '../layouts/SectionComposition';
import Heading from '../layouts/Heading';
import { SkillsData } from '../data/SkilsData';

const Skills = () => {



  return (
    <>
      <PageTitle title="Skills" />

      {/* <PageHeader headerTitle="Skills" /> */}

      <SectionComposition bgColor="off-white">
        <div className="container-xxl">
          <div className="container">

            <Heading headingTitle="My Skills" />

            <div className="row justify-content-center">
              <div className="col-lg-10">

                {SkillsData.map((skill, index) => (
                  <div
                    className="mb-4"
                    key={index}
                  >
                    <div className="d-flex justify-content-between mb-2">
                      <label className="fw-semibold">
                        {skill.name}
                      </label>

                      <span className="fw-semibold">
                        {skill.percentage}%
                      </span>
                    </div>

                    <div
                      className="progress"
                      style={{ height: '10px' }}
                    >
                      <div
                        className={`progress-bar progress-bar-animated ${skill.className}`}
                        role="progressbar"
                        style={{ width: `${skill.percentage}%` }}
                        aria-valuenow={skill.percentage}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            </div>

          </div>
        </div>
      </SectionComposition>
    </>
  );
};

export default Skills;

